<template>
    <div class="item-list list-info"
         :class="data.classArrowDirPos"
         :style="[data.styleList, props.stylePos]"
    >
        <slot></slot>
    </div>
</template>

<script>

    import {ref, reactive, onMounted, onUpdated, watchEffect, watch, computed, nextTick,inject}  from "vue"

    const MARGIN_ITEM_LIST_TOP = 10; //margin between the selected label display and the item list

    export default {
        props: {
            arrowVerticalDirection:String,
            arrowHorizontalPosition:String,
            isToggle:Boolean,
            stylePos:Object,
            triggerId:String //the element id of the button that toggles the simple list
        },
        setup(props, context) {

            const i18n = inject('i18n');

            const data = reactive({
                isShow:false,
                classArrowDirPos:computed(()=>{
                    return {
                        "up": props.arrowVerticalDirection === "up" ||  props.arrowVerticalDirection === undefined,
                        "down":  props.arrowVerticalDirection === "down",
                        "left": props.arrowHorizontalPosition === "left" || props.arrowHorizontalPosition === undefined,
                        "right": props.arrowHorizontalPosition === "right"
                    }
                }),
                styleList:computed(()=>{
                    return {
                        display: (data.isShow) ? "block" : "none",
                    }
                })
            })


            /**
             * if any empty are except the trigger button is clicked, close the listings
             * @param e
             */
            const bodyOnClicked = (e)=>{

                let parents = getParents(e.target);

                //if the event target is list item, ignore this handler and continue to process what the target is expected to do when clicked.
                if (parents) {
                    for (let parent of parents) {
                        if (parent.classList && parent.classList.contains("item-list")) {
                            console.log(e.target);
                            document.querySelector("body").removeEventListener("click", bodyOnClicked, true)
                            setTimeout(()=>{
                                data.isShow = false;
                            },50);
                        }
                    }
                }

                if (!e.target.id || e.target.id  !== props.triggerId ) {
                    data.isShow = false;
                }
            }

            const getParents =  (el)=>{
                let parents = [],
                    node = el;
                while (node != document) {
                    parents.push(node.parentNode);
                    node = node.parentNode;
                }
                return parents;
            }

            watch(
                () => props.isToggle,
                (newVal, oldVal) => {
                    if (!data.isShow) {
                        if (newVal === true) {
                            data.isShow = true;
                            document.querySelector("body").addEventListener("click", bodyOnClicked, true);
                        }
                    } else {
                        if (newVal === false) {
                            data.isShow = false;
                            document.querySelector("body").removeEventListener("click", bodyOnClicked, true);
                        }
                    }
                }
            )

            watchEffect(()=>{
                if (!data.isShow) {
                    context.emit("hidden")
                }
            })


            return {
                i18n,
                props,
                data,
            }
        }

    }
</script>

<style  lang="scss">

    .item-list {
        position:absolute;
        background:#fff;
        box-shadow:3px 3px 10px #999;
        border-radius:6px;
        display:none;

        .item {
            padding:6px;
            width:100%;
            box-sizing: border-box;
            display:block;
            color:$text-color-primary;
            text-shadow:none;
            word-brek:break-word;
            font-weight:300;
            @include transition(all, 0.4s, ease-in);
        }

        & > a {

            &:hover {
                background:$color-ui-active;
            }

            &:first-child {
                border-radius:$list-item-border-radius $list-item-border-radius 0 0 ;
            }

            &:last-child {
                border-radius:0 0 $list-item-border-radius $list-item-border-radius;
            }
        }

        .list-inner-btn {
            pointer-events: auto !important;
        }

        .item-with-options {
            display:flex;
            align-items: center;

            .label {
                margin:0 5px;
            }
        }

        .item-options-btn {
            //background:$color-primary;
            @include btn-gradient($color-gradient-green-start, $color-gradient-green-end, #fff);
            padding:5px 10px;
            border-radius:6px;
            margin:5px;
            color:#fff;
            position:relative;

            .tick {
                margin: 0 25px 0 0;
                &::before {
                    content: "✔\fe0e";
                    position:absolute;
                    left:10px;
                }
            }

            &.deactive {
                @include btn-gradient($color-gradient-grey-start, $color-gradient-grey-end, #000);
                color:$text-color-primary !important;
            }
        }
    }

    .item-list.up .item {
        border-top:1px solid $color-ui-border;
    }

    .item-list.down .item {
        border-bottom:1px solid $color-ui-border;
    }

    .item-list.up::after {
        position: absolute;
        content: "";
        display: block;
        top: -9px;
        left: 14px;
        width: 20px;
        height: 10px;
        border-bottom: solid 10px #fff;
        border-left: solid 10px transparent;
        border-right: solid 10px transparent;
        box-sizing: border-box;
    }

    .item-list.right::after {
        left:inherit;
        right:10px;
    }

    .item-list.down::after {
        position: absolute;
        content: "";
        display: block;
        top:calc(100% - 1px);
        left: 14px;
        width: 20px;
        height: 10px;
        border-top: solid 10px #fff;
        border-left: solid 10px transparent;
        border-right: solid 10px transparent;
        box-sizing: border-box;
    }

</style>